// tRPC queries are GETs, so a list a query carries (lead ids, recipient terms)
// travels in the URL. The client's maxURLLength (trpc/TRPCProvider.tsx) rejects
// any single operation past it without ever sending it — roughly 195 lead ids —
// so every such list is split into chunks well under that and fetched in parallel.
export const QUERY_CHUNK_SIZE = 100;

export const chunk = <T>(items: T[], size = QUERY_CHUNK_SIZE): T[][] =>
  Array.from({ length: Math.ceil(items.length / size) }, (_, i) =>
    items.slice(i * size, (i + 1) * size)
  );
